/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_Faq_Q2Inputs */

const en_guide_json_syntax_errors_faq_q2 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I validate JSON without a tool?`)
};

const ko_guide_json_syntax_errors_faq_q2 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도구 없이 JSON의 유효성을 검사할 수 있나요?`)
};

const ja_guide_json_syntax_errors_faq_q2 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールなしでJSONを検証できますか？`)
};

/**
* | output |
* | --- |
* | "Can I validate JSON without a tool?" |
*
* @param {Guide_Json_Syntax_Errors_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_faq_q2 = /** @type {((inputs?: Guide_Json_Syntax_Errors_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_faq_q2(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_faq_q2(inputs)
	return ja_guide_json_syntax_errors_faq_q2(inputs)
});